import { useFetchFromServer } from '../../../api/fetchHook'
import { EngineStatus } from '../../../../../shared/src/data/engineStatus'
import { useQuery } from 'react-query'
import { engineStateKeyFactory } from './engineStateKeyFactory'

const URL = process.env.PUBLIC_URL + '/api/engineState'

export const useEngineStateQuery = () => {
  const { fetchJsonFromServer } = useFetchFromServer()

  return useQuery(
    engineStateKeyFactory.all,
    () => fetchJsonFromServer<{ state: EngineStatus }>(URL),
    {
      select: ({ state }) => state,
    },
  )
}
